import React, { Component } from "react";
import { connect } from "react-redux";

import { submitSupportVoteApi } from "@lib/api";
import { addAlert } from "@store/app/actions";

import FeedbackForm from "@containers/Support/FeedbackForm";

class Feedback extends Component {
  state = {
    vote: null,
    formIsActive: true,
  };

  voteHandler = async (type, values = null) => {
    const voteRes = await submitSupportVoteApi(type, {
      article_slug: this.props.articleSlug,
      category_slug: this.props.categorySlug,
      ...(values ? { form: values } : null),
    });

    if (!voteRes.ok) {
      this.props.addAlert({
        message: `Nu s-a putut trimite mesajul. Te rugam sa incerci din nou.`,
        variant: "error",
      });

      return null;
    }

    this.setState({
      vote: type,
      ...(values ? { formIsActive: false } : null),
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.articleSlug !== prevProps.articleSlug) {
      this.setState({
        vote: null,
        formIsActive: true,
      });
    }
  }

  render() {
    return (
      <>
        {(!this.state.vote || this.state.vote === "downvote") && (
          <div className="flex items-center px-4 py-3 text-sm bg-newGray-light">
            <div className="mr-2 -tracking-0.29">{`Ti-a fost de ajutor acest raspuns?`}</div>

            <div className="ml-3">
              <button
                type="button"
                onClick={() =>
                  !this.state.vote ? this.voteHandler("upvote") : ""
                }
                className="py-1 px-2 text-white bg-bleu sm:hover:bg-bleu-hover sm:focus:bg-bleu-active rounded outline-none"
              >
                {`Da`}
              </button>
            </div>

            <div className="ml-2">
              <button
                onClick={() =>
                  !this.state.vote ? this.voteHandler("downvote") : ""
                }
                type="button"
                className="py-1 px-2 text-white bg-bleu sm:hover:bg-bleu-hover sm:focus:bg-bleu-active rounded outline-none"
              >{`Nu`}</button>
            </div>
          </div>
        )}

        {this.state.vote && (
          <div
            className={`p-5 text-sm
            ${this.state.vote === "downvote" ? "border-gray-1100 border-t" : ""}
          `}
          >
            {this.state.vote === "downvote" && this.state.formIsActive ? (
              <>
                <p className="block mb-3 text-black">
                  {`Cum putem imbunatati acest raspuns?`}
                </p>

                <FeedbackForm
                  submitFeedback={(values) =>
                    this.voteHandler("downvote", values)
                  }
                />
              </>
            ) : (
              <p className="-traking-0.29">{`Iti multumim pentru feedback.`}</p>
            )}
          </div>
        )}
      </>
    );
  }
}

export default connect(null, { addAlert })(Feedback);
